import { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { FiLock, FiArrowLeft, FiCheckCircle } from 'react-icons/fi';
import { resetPassword } from '../../services/api';
import styles from './ForgotPassword.module.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    setError('');
    try {
      await resetPassword(token, form.password);
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {done ? (
          <>
            <FiCheckCircle size={48} style={{ color: 'var(--color-success)', marginBottom: 20 }} />
            <h2 className={styles.title}>Password Reset!</h2>
            <p className={styles.desc}>Your password has been updated successfully. Redirecting you to the sign-in page…</p>
            <Link to="/login" className={styles.backLink}><FiArrowLeft size={13} /> Sign In now</Link>
          </>
        ) : (
          <>
            <div className={styles.iconBox}><FiLock size={24} /></div>
            <h2 className={styles.title}>Set New Password</h2>
            <p className={styles.desc}>Enter a new password for your account. Must be at least 6 characters.</p>
            {error && <div className={styles.errorMsg}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>New Password *</label>
                <input
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="At least 6 characters"
                  required
                  minLength={6}
                />
              </div>
              <div className="form-group">
                <label>Confirm New Password *</label>
                <input
                  name="confirm"
                  type="password"
                  value={form.confirm}
                  onChange={handleChange}
                  placeholder="Re-enter password"
                  required
                  minLength={6}
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: 8 }}>
                {loading ? 'Updating…' : 'Reset Password'}
              </button>
            </form>
            <Link to="/login" className={styles.backLink}><FiArrowLeft size={13} /> Back to Sign In</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
